import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

const getMainHoursState = (state: RootState) => state.mainHours;

export const getMainHoursDataSelector = createSelector(
  [getMainHoursState],
  (mainHours) => mainHours?.mainHoursData,
);

export const getMainHoursIsSaveSelector = createSelector(
  [getMainHoursState],
  (mainHours) => mainHours?.isSave,
);

export const getMainHoursIsErrorSelector = createSelector(
  [getMainHoursState],
  (mainHours) => mainHours?.isError,
);

export const getMainHoursStatusSelector = createSelector(
  [getMainHoursState],
  (mainHours) => mainHours?.mainHoursStatus,
);
